module.exports = __webpack_public_path__ + "static/media/mon_sun_everyday_digital_footy2024.a95de08c.webp";